import React from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

var listaunidadest=[];
var tipoveiculo1=[]; 
export default function  ParadaMap (props) {

    console.log(props);
    console.log(props);
    const [statelista, setalista]=React.useState([{
        id:'', label:''
    }]);
const [statetipoveiculo,setatipoveiculo]=React.useState([{
    id:'', label:''
}]);
const[codtipo,setacodtipo]=React.useState('');
    React.useEffect (()=>{
        
        firebase.firestore().collection("tiposveiculo")
        .get()
        .then(function(querySnapshot) {
            listaunidadest=[];
            querySnapshot.forEach(function(doc) {
                listaunidadest.push({id: doc.id, label: doc.data().tipoveiculo,
                listacatmotoras: doc.data().categoriasmotorista, valorkmrodado:doc.data().valorkmrodado,
                });
            })
            setalista(listaunidadest)
            console.log("listass tipos de veiculos: ", listaunidadest);
        })
        .catch(function(error) {
            console.log("erro carregar as unidades de tipos veiculos: ", error);
            alert('Não foi Possível carregar os tipos de veículos.');
        });
         
        
            setacodtipo(props.cod)
        
       
            if (props.cod!='') {
                pegatipoveiculo();
            }
            async function pegatipoveiculo(){
                
                var ut =  firebase.firestore().collection("tiposveiculo").doc(props.cod);
                console.log("valor do cod ", props.cod);
                  ut.get()
                  .then((doc) => { 
                         
                    if (doc.exists) {
                        tipoveiculo1=[];
                        tipoveiculo1.push({id: doc.id, label: doc.data().tipoveiculo});
                      
                      console.log("valor requirid dentro do tipo transporte123  ", tipoveiculo1);
                      setatipoveiculo(tipoveiculo1);
                      props.setatipoveiculo(tipoveiculo1);
                    }
                  })
                  .catch(function(error) {
                      console.log("Erro ao carregar (tipos de veículos): ", error);
                  });
              }
        
            },[0])


           
   

    const handleuniade=(event,value)=>{
       
        setatipoveiculo([value]);
        console.log("targekkkkkkkkkkkkkkkkkkt ", value);
        if((value!=undefined)||(value!=null)){
        props.setatipoveiculo([value]);
        console.log("targekkkkkkkkkkkkkkkkkkt ", value);
        //setatipoveiculo(value),
        }
       
    }
    console.log("target4 ", props.props)
    return(
        <Autocomplete onChange={handleuniade}
                    

                    id="combounidadetchef"
                    options={statelista}
                    disabled={props.disabled}
                    getOptionLabel={(option) =>(typeof option === 'string' ? option :option.label)}
                   // value={tipoveiculo1[0]}
                   value={statetipoveiculo[0]}
                   //defaultValue={tipoveiculo1[0]}
                   getOptionSelected={(option,temp) => option.id==temp.id}
                    renderInput={(params) => <TextField {...params}  required={props.requer}  label="Tipo de Veículo" variant="outlined" />}
                />
                
)
}